export const hasBeenDeleted = (entity) => entity?.deleteDate !== null && entity?.deleteDate !== undefined;
